function normalizedValue(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function resolvePublishingCategoryId(value, categories) {
  const selectedValue = normalizedValue(value);
  if (!selectedValue) return "";

  const category = (categories || []).find(
    item =>
      item.id === selectedValue || normalizedValue(item.name).toLocaleLowerCase() === selectedValue.toLocaleLowerCase()
  );

  return category?.id || "";
}

export function resolvePublishingCategoryName(categoryId, categories) {
  return (categories || []).find(category => category.id === categoryId)?.name || "";
}
